import {FC} from "react";

interface Props {

}

const SpaceDetailsInfoList: FC<Props> = (props) => {
    return (
        <ul className='mt-5 space-y-2'>
            {props.children}
        </ul>
    );
};

export default SpaceDetailsInfoList;